import React from "react";
import { Box, Chip, Grid } from "@mui/material";
import { GridCellStack } from "@ui/components/grid";
import { Icon } from "@iconify/react";
import { SignalMeter } from "@ui/components/icons/SignalMeter";
import { StatusIndicator } from "@ui/components/status";
import { formatUtcToLocalDate, formatUtcToLocalTime, } from "@application/common/helpers/date-util";
import { useTranslation } from "react-i18next";
import { MobileCard } from "@ui/components/card";
import { SMenu } from "@ui/components/menu/SMenu";
import { SIconButton } from "@ui/components/buttons";
import { IconText } from "@ui/components/info/IconText";
import { between } from "@ui/components/style/style";
export const DashboardDeviceCard = ({ row, onViewNodes, onDelete, onSettings, onMaintenance, showDelete, showSettings, }) => {
    const { t } = useTranslation(["common"]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const isActive = row.status === "active";
    const handleMenuOpen = (e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };
    const menuItems = [
        {
            label: t("common:actions.nodes"),
            onClick: () => onViewNodes(row.deviceId),
        },
        ...(showSettings && onSettings
            ? [
                {
                    label: t("common:actions.settings"),
                    onClick: () => onSettings(row.deviceId),
                },
            ]
            : []),
        ...(row.hasMaintenanceRequest && onMaintenance
            ? [
                {
                    label: t("common:actions.maintenance"),
                    onClick: () => onMaintenance(row.deviceId, row.name),
                },
            ]
            : []),
        ...(showDelete && onDelete
            ? [
                {
                    label: t("common:actions.delete"),
                    onClick: () => onDelete(row.deviceId, row.name),
                    color: "error",
                },
            ]
            : []),
    ];
    return (React.createElement(MobileCard, { onClick: () => onViewNodes(row.deviceId) },
        React.createElement(Box, { sx: { display: "flex", alignItems: "flex-start", gap: 1 } },
            React.createElement(Box, { sx: { flexShrink: 0 } },
                React.createElement(SignalMeter, { width: 60, height: 52, variant: isActive ? "success" : "warning" })),
            React.createElement(Box, { sx: { flex: 1, minWidth: 0 } },
                React.createElement(GridCellStack, { topText: row.name, bottomText: row.deviceId, topStyle: { fontWeight: 600, lineHeight: "22px" }, bottomVariant: "caption", bottomColor: "text.secondary" })),
            React.createElement(SIconButton, { size: "small", colorVariant: "inherit", showBackground: false, onClick: handleMenuOpen },
                React.createElement(Icon, { icon: "eva:more-vertical-fill", color: "#231F20" })),
            React.createElement(SMenu, { anchorEl: anchorEl, open: Boolean(anchorEl), handleClose: () => setAnchorEl(null), menuItems: menuItems })),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { size: 6 },
                React.createElement(IconText, { icon: "solar:calendar-linear", text: formatUtcToLocalDate(row.lastUpdate) })),
            React.createElement(Grid, { size: 6 },
                React.createElement(IconText, { icon: "solar:clock-circle-linear", text: formatUtcToLocalTime(row.lastUpdate) }))),
        React.createElement(Box, { sx: Object.assign({}, between) },
            React.createElement(StatusIndicator, { variant: row.status }),
            React.createElement(Chip, { label: `${row.nodeCount} ${t("common:grid.devices")}`, size: "small", variant: "soft", color: "default" }))));
};
